// extracted by mini-css-extract-plugin
module.exports = {"root":"formLabel_root__1kkBZ","redAsterisk":"formLabel_redAsterisk__3VzsN","errorMsg":"formLabel_errorMsg__mvcPV"};